import { Injectable } from '@angular/core';

/**
 * Eine Utilklasse, die ein Wrapper für das window-Objekt zur Verfügung stellt.
 * Es ist nicht empfohlen das window-Objekt (auch wie andere Browser Native Objekten) mit Angular direkt benutzen.
 */
@Injectable()
export class WindowRef {
    get nativeWindow(): Window {
        return window;
    }
}
